// Import the components of the interface.
import api from './api'
import reducer from './reducers'

/**
 * This interface is for a call plugin.
 * @type {string}
 */
const name = 'call'

// Export the interface as a single object.
export default {
  name,
  api,
  reducer
}
